import { DocumentSearchService } from '../../_api/services/document-search.service';
import { Router } from "@angular/router";
import { LanguageService } from '../../../../shared/services/language.service';
import {
  Component,
  OnInit,
  Input,
  Output, EventEmitter
} from '@angular/core';

@Component({
  selector: 'app-document-operator-search-detail',
  templateUrl: './document-operator-search-detail.component.html',
  styleUrls: ['./document-operator-search-detail.component.css']
})
export class DocumentOperatorSearchDetailComponent implements OnInit {

  @Input() dataSource: any[];
  @Output() rowClicked = new EventEmitter<any>();
  @Output() loading = new EventEmitter<boolean>();

  popoverVisible: boolean = false;
  popoverTarget: any;
  popoverText: any;

  constructor(public languageService: LanguageService, public documentSearchService: DocumentSearchService, public router: Router) { }

  abs(value) {
    return Math.abs(value);
  }

  ngOnInit(): void {

  }

  labels = {
    Name: this.languageService.LNG('Label.Name'),
    SearchFreeText: this.languageService.LNG('Label.SearchFreeText'),
    Type: this.languageService.LNG('Label.Type'),
    Category: this.languageService.LNG('Label.Category'),
    Version: this.languageService.LNG('Label.Version'),
    Codes: this.languageService.LNG('Label.Codes'),
    Attributes: this.languageService.LNG('Label.Attributes'),
    Types: this.languageService.LNG('Label.Types'),
    number: this.languageService.LNG("Label.NumberNumber")
  }

  ngOnChanges() {
  }

  contentReady(e: any) {
    if (!e.component.getSelectedRowKeys().length) { e.component.selectRowsByIndexes(0); }
  }

  selectionChanged(e: any) {
    e.component.collapseAll(-1);
    e.component.expandRow(e.currentSelectedRowKeys[0]);
  }

  onSelectionChanged(event: any) {
    this.rowClicked.emit(event);
  }

  sortByName(rowData) {
    return rowData.DocumentDetails.line3;
  }

  onCellHoverChanged(e) {
    if (e.rowType === "data" && e.column.cellTemplate === "documentTemplate" && e.eventType === "mouseover") {
      this.popoverText = e.text;
      this.popoverTarget = e.cellElement;
      this.popoverVisible = true;
    }
    if (e.rowType === "data" && e.eventType === "mouseout") {
      this.popoverVisible = false;
    }
  }
}


